import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="otp"
export default class extends Controller {
static targets = ["field", "attempt"];

  connect() {
    this.resetOtpAttempt();
  }

  input(event) {
    const currentField = event.target;

    if (currentField.value && this.nextField(currentField)) {
      this.nextField(currentField).focus();
    }

    this.resetOtpAttempt();
  }

  keydown(event) {
    const currentField = event.target;

    if (event.key === "Backspace" && !currentField.value) {
      const previousField = this.previousField(currentField);

      if (previousField) {
        previousField.focus();
      }
    }
  }

  paste(event) {
    const pastedData = (event.clipboardData || window.clipboardData)
      .getData("text")
      .split("");

    this.fieldTargets.forEach((field, index) => {
      field.value = pastedData[index] || "";
    });

    this.resetOtpAttempt();

    event.preventDefault();
  }

  resetOtpAttempt() {
    const otpAttempt = this.fieldTargets
      .map((field) => field.value)
      .join("");

    this.attemptTarget.value = otpAttempt;
  }

  nextField(currentField) {
    const index = this.fieldTargets.indexOf(currentField);
    return this.fieldTargets[index + 1];
  }

  previousField(currentField) {
    const index = this.fieldTargets.indexOf(currentField);
    return this.fieldTargets[index - 1];
  }
}
